module.exports = __webpack_public_path__ + "img/tverrprofil.9a996830.jpg";